import { DIALOG_DATA } from '@angular/cdk/dialog';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef } from '@angular/material/dialog';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { PricingComponent } from '../../pricing/pricing.component';

export enum SubscriptionUpgradeReason {
  General = 'general',

  MaxKnowledgeBaseCountReached = 'max-knowledge-base-count-reached',

  MaxArticleCountReached = 'max-article-count-reached',

  MaxKnowledgeBaseDomainCountReached = 'max-knowledge-base-domain-count-reached',

  MissingFormNotificationsFeature = 'missing-form-notifications-feature',
}

export interface SubscriptionUpgradeDialogData {
  reason: SubscriptionUpgradeReason;
}

@Component({
  selector: 'app-subscription-upgrade-dialog',
  imports: [
    PricingComponent,
    FaIconComponent,
    MatButtonModule,
  ],
  templateUrl: './subscription-upgrade-dialog.component.html',
  styleUrl: './subscription-upgrade-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SubscriptionUpgradeDialogComponent {
  constructor(
    @Inject(DIALOG_DATA) protected data: SubscriptionUpgradeDialogData,
    private _dialogRef: MatDialogRef<SubscriptionUpgradeDialogComponent>,
  ) {
  }

  protected close() {
    this._dialogRef.close();
  }

  protected readonly SubscriptionUpgradeReason = SubscriptionUpgradeReason;
  protected readonly faTimes = faTimes;
}
